<template>
  <PageTable :orderCode="orderCode" :disabled="true" />
</template>
<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    orderCode: { type: String, default: '' },
  },
}
</script>
